import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[boschUiHeaderCellDef]',
})
export class BoschUiHeaderCellDefDirective<DataType> {
  constructor(public templateRef: TemplateRef<DataType>) {}
}
